import React from "react";
import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EnergyAssistanceChart from "../../Chart";
import EnergyUsageDownload from "../../EnergyUsageDownload";
import { initialState } from "container/energyAssistance/store/initialState";
import { API_LOAD_STATUS } from "constants/labels";
import { getEnergyUsage, getTooltipMsgs } from "selectors/energyAssistance.selectors";
import { useSelector } from "react-redux";
import { InfoTooltip } from "_components";

const EnergyUsage = () => {
  const energyUsage = useSelector(getEnergyUsage);
  const tooltipMsgs = useSelector(getTooltipMsgs);
  const getTooltip = (title) =>
    tooltipMsgs?.Data?.find((t) => t.TooltipTitle === title)?.TooltipMsg;
  const { Load, Succeeded } = energyUsage || initialState.energyUsage;

  return (
    <Box
      className="userInformationcontainer EnergyAssistanceChartcontainer"
      sx={{ height: "100% !important" }}
    >
      <Accordion component="div" defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          component="div"
        >
          <Box
            onClick={(e) => {
              e.stopPropagation();
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography component="h2" className="userInformation">
              ENERGY USAGE
              <InfoTooltip
                title="Energy Usage"
                message={getTooltip("Energy Usage")}
              />
            </Typography>
            <EnergyUsageDownload />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          {Load.status === API_LOAD_STATUS.FULFILLED && Succeeded && (
            <Grid container>
              <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                <EnergyAssistanceChart />
              </Grid>
            </Grid>
          )}
          {Load.status === API_LOAD_STATUS.PENDING && (
            <Typography component="p" sx={{ textAlign: "center" }}>
              Loading Energy Usage...
            </Typography>
          )}
          {(Load.status === API_LOAD_STATUS.REJECTED ||
            Load.status === API_LOAD_STATUS.FULFILLED) &&
            !Succeeded && (
              <Typography component="p" sx={{ textAlign: "center" }}>
                {Load.message || "No records to display."}
              </Typography>
            )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default EnergyUsage;
